class CustomVideoElement extends HTMLElement {
	/** @type {HTMLElement} */
	static lightbox = null;

	/**
	 * Handles lightbox generation and population
	 * @param {string} src 
	 */
	static show(src) {
		if (!this.lightbox) {
			this.lightbox = document.createElement("div");
			this.lightbox.id = "video--lightbox";

			let background = document.createElement("span");
			background.classList.add("video--background");

			background.addEventListener("click", () => {
				this.lightbox.classList.remove("open");
				
				setTimeout(() => iframe.src = "", 500);
			});
			
			let iframe = document.createElement("iframe");
			iframe.setAttribute("allowfullscreen", "");

			this.lightbox.append(background, iframe);

			document.body.append(this.lightbox);
		}

		this.lightbox.classList.add("open");

		this.lightbox.children[1].src = src;
	}

	constructor() {
		super();

		this.classList.add("idle");

		this.poster = document.createElement("img");
		this.poster.src = this.hasAttribute("poster") ? this.getAttribute("poster") : "http://placehold.it/800?text=Missing%20Poster";
		this.poster.width = this.hasAttribute("width") ? this.getAttribute("width") : "800";
		this.poster.height = this.hasAttribute("height") ? this.getAttribute("height") : "450";

		this.play = document.createElement("a");
		this.play.href = "javascript:;";
		this.play.classList.add("play");

		this.addEventListener("click", () => {
			CustomVideoElement.show(this.getAttribute("src"));
		});

		this.append(this.poster);
		this.append(this.play);
	}
}

customElements.define("san-video", CustomVideoElement);